import React from 'react'
import DocumentTitle from 'react-document-title'

import {withStyles} from 'material-ui'

import Footer from './Footer'

const styles = theme => ({
    container: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
    },
    grow: {
        flex: 1
    }
})

export const TitledPage = withStyles(styles)(
    ({classes, title, children, nologo}) => (
        <DocumentTitle title={title}>
            <div className={classes.container}>
                {children}
                <div className={classes.grow}/>
                <Footer/>
            </div>
        </DocumentTitle>
    )
)

export default TitledPage


// WEBPACK FOOTER //
// ./src/components/TitledPage.jsx